import React from 'react';
import {
  avTooltipProps,
  DATE_BUCKET_OPTIONS,
  DATE_BUCKET_OPTIONS_ARR,
  DimTypes,
  EXPLODE_OPTION,
  EXPLODE_OPTIONS,
  FeatureFlags,
  FieldTypes,
  NOT_EXPLODE_OPTION,
  RepeatedDimType,
} from '@fabric-ui/components';
import { FormatterType } from '@fabric-ui/components/Table';
import { TooltipProps } from '@mui/material';
import { checkIsNoneDateBucket, getDateBucketFromExpression } from '@views/CustomDashboards/CustomDashboardsUtils/expressionUtils';
import { useAvContext } from '../../context/AvContextProvider';
import DescriptionTooltip from './popupByType/DescriptionTooltip';
import OptionsPopup from './popupByType/OptionsPopup';

const INITIAL_ENABLED_FIELD_TYPES_WITH_OPTIONS = new Set([FieldTypes.Measurement]);

interface BaseProps {
  enabledFieldTypesWithOptions?: Set<string | undefined>;
  tooltipProps?: Omit<TooltipProps, 'children'> & { id: `${string}-${string}-${string}-${string}-${string}` };
}

export type FieldOptionsProps = BaseProps & { type?; selectedFields?; field?; onApply? };

export default function FieldOptions(props: FieldOptionsProps) {
  const { type, enabledFieldTypesWithOptions = INITIAL_ENABLED_FIELD_TYPES_WITH_OPTIONS, tooltipProps } = props;
  const { featureFlags } = useAvContext();

  if (enabledFieldTypesWithOptions.has(FieldTypes.Measurement) && (type === FieldTypes.Measurement || !type)) {
    return <DescriptionTooltip avTooltipProps={avTooltipProps} tooltipProps={tooltipProps} />;
  }

  if (
    featureFlags[FeatureFlags.DateDimBucket] &&
    enabledFieldTypesWithOptions.has(FormatterType.date) &&
    type === DimTypes.Date &&
    props.selectedFields[props.field.value]
  ) {
    const { field } = props;
    const { selectedFields } = props;

    const initialValue = field.expression
      ? DATE_BUCKET_OPTIONS[getDateBucketFromExpression(field.expression)].value
      : DATE_BUCKET_OPTIONS.none.value;

    const shouldDisplayIcon =
      selectedFields &&
      selectedFields[field.value] &&
      selectedFields[field.value].expression &&
      !checkIsNoneDateBucket(getDateBucketFromExpression(selectedFields[field.value].expression));

    return (
      <OptionsPopup
        fieldName={field.title}
        onApply={props.onApply}
        initialValue={initialValue}
        label="Group Date By"
        options={DATE_BUCKET_OPTIONS_ARR}
        shouldDisplayIcon={shouldDisplayIcon}
      />
    );
  }

  if (
    type === RepeatedDimType.String &&
    props.selectedFields[props.field.value] &&
    featureFlags[FeatureFlags.ExplodeGroup] &&
    enabledFieldTypesWithOptions.has(FormatterType.array)
  ) {
    const shouldDisplayIcon = props.selectedFields[props.field.value].expression;
    const initialValue = props.field.expression ? EXPLODE_OPTION.value : NOT_EXPLODE_OPTION.value;

    return (
      <OptionsPopup
        fieldName={props.field.title}
        onApply={props.onApply}
        initialValue={initialValue}
        label="Repeated field display"
        options={EXPLODE_OPTIONS}
        shouldDisplayIcon={shouldDisplayIcon}
      />
    );
  }

  return undefined;
}
